// Pure, dependency-free pagination math. Given a total item count, a requested
// page, and a page size, compute the clamped page and the slice bounds. The
// caller stays valid even with an out-of-range `page` (e.g. after items are
// added or removed) because `safePage` is always clamped into range.
//
// Returns { totalPages, safePage, start, end }:
//   totalPages = max(1, ceil(total / pageSize))  — never zero, so there is
//                always a page to show even for an empty list.
//   safePage   = page clamped to [1, totalPages].
//   start      = (safePage - 1) * pageSize        — inclusive slice start.
//   end        = min(start + pageSize, total)     — exclusive slice end.

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function paginate(totalCount, page, pageSize) {
  const total = Math.max(0, totalCount);
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = clamp(page, 1, totalPages);
  const start = (safePage - 1) * pageSize;
  const end = Math.min(start + pageSize, total);
  return { totalPages, safePage, start, end };
}
